import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Papa from "papaparse";

import "./Responses.css";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_FORM_RESPONSES } from "../../GraphQl/Queries";
import { useParams } from "react-router-dom";
import { EmailEncryption, maskPhoneNumber } from "../../functions";
import { emailRegex, phoneNumberRegex } from "../../constants/Regex";
import { GET_ANALYTICS } from "../../GraphQl/Mutations";
import { FaSpinner } from "react-icons/fa";
import Loader from "../Loader";

const Responses = () => {
  const state = useSelector((state) => state.allForms);
  const params = useParams();
  const [responses, setResponses] = useState([]);
  const [localresponses, setLocalResponses] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [load, setLoad] = useState(false);
  const [getResponses, { loading, data, error }] = useLazyQuery(
    GET_FORM_RESPONSES,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        getFormByIdAId: params?.id,
      },
      onCompleted: (data) => {
        setResponses(data?.getFormByIdA);
      },
    }
  );
  const [getAnalytics] = useLazyQuery(GET_ANALYTICS, {
    fetchPolicy: "cache-and-network",
    variables: {
      getQuestionResponsesId: params?.id,
    },
    onCompleted: (data) => {
      let temp = {};

      data?.getQuestionResponses?.forEach(
        (item) => (temp[item?.questionTitle] = item?.corResponse)
      );
      console.log("tempdata is ", temp);
      setLocalResponses(temp);

      setLoad(false);
    },
    onError: (err) => {
      console.log(err);
    },
  });
  const form = useSelector((state) => state?.allForms?.currentForm);
  useEffect(() => {
    getResponses();
    getAnalytics();
  }, []);

  useEffect(() => {
    setResponses(state?.currentForm?.responses);
    setQuestions(state?.currentForm?.questions);
  }, [state]);

  const exportToCsv = (data) => {
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    console.log(data, csv);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", form?.formTitle + ".csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  function convertJSON(json) {
    const keys = Object.keys(json);
    const maxArrLength = Math.max(...keys.map((key) => json[key].length));
    const result = [];

    for (let i = 0; i < maxArrLength; i++) {
      const obj = {};
      for (let j = 0; j < keys.length; j++) {
        const key = keys[j];
        let value;
        if (emailRegex.test(json[key][i]))
          value = EmailEncryption(json[key][i]);
        else if (phoneNumberRegex.test(json[key][i]))
          value = maskPhoneNumber(json[key][i]);
        else if (
          !emailRegex.test(json[key][i]) &&
          !phoneNumberRegex.test(json[key][i])
        )
          value = json[key][i];

        // Check if value is a string and contains valid JSON
        if (
          typeof value === "string" &&
          value.startsWith("[") &&
          value.endsWith("]")
        ) {
          try {
            value = JSON.parse(value);
          } catch (e) {
            console.error(`Error parsing value: ${value}`);
          }
        }

        obj[key] = value;
      }
      result.push(obj);
    }
    if (result != []) exportToCsv(result);
  }
  const fetchAnalytics = () => {
    setLoad(true);
    getAnalytics();
    setTimeout(() => {
      convertJSON(localresponses);
    }, 100);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        padding: "2.5%",
      }}
    >
      <div style={{ width: "100%" }}>
        {loading ? (
          <div
            className='viewerFormBox flex flex-row'
            style={{ width: "100%", margin: "0 auto" }}
          >
            <span className='fw-bold mx-5 text-lg'>
              <Loader />
              Loading..
            </span>
          </div>
        ) : (
          responses?.responseDetails &&
          responses?.questions?.map((question) => (
            <div className='responseWrapper mb-3'>
              <h5 className='fw-bold' style={{ padding: "1%" }}>
                {" "}
                {question?.questionTitle}
              </h5>
              <div
                className='response-scrollbar'
                style={{
                  minHeight: "50px",
                  overflowY: "scroll",
                  background: "#fff",
                  padding: "1%",
                  width: "98%",
                  margin: "0 auto",
                  borderRadius: "5px",
                  border: "3px solid #151515",
                }}
              >
                {responses?.responseDetails?.responses?.map((response) => (
                  <h6>
                    {response?.response
                      ?.filter((res) => res?.questionId === question?.id)
                      ?.map((res) => (
                        <>
                          {emailRegex.test(res?.responseText) &&
                            EmailEncryption(res?.responseText)}
                          {phoneNumberRegex.test(res?.responseText) &&
                            maskPhoneNumber(res?.responseText)}
                          {!emailRegex.test(res?.responseText) &&
                            !phoneNumberRegex.test(res?.responseText) &&
                            res?.responseText}
                        </>
                      ))}
                  </h6>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
      {!loading &&
        (responses?.length == 0 || responses?.responseDetails == null) && (
          <div
            className='viewerFormBox flex flex-row'
            style={{ width: "90%", margin: "0 auto" }}
          >
            <span className='fw-bold mx-5 text-lg'>
              No responses available !
            </span>
          </div>
        )}
      {!loading &&
        !(responses?.length == 0 || responses?.responseDetails == null) && (
          <>
            <button
              className='btn btn-warning border-2 border-dark'
              onClick={() => {
                fetchAnalytics();
                // console.log("downloading", localresponses);
                // downloadFile({
                //   data: JSON.stringify(localresponses),
                //   fileName: "response.csv",
                //   fileType: "text/csv",
                // });
              }}
              style={{ margin: "1%" }}
            >
              {load && <Loader color='#111' />}
              Download Data
            </button>
          </>
        )}
    </div>
  );
};

export default React.memo(Responses);
